// import axios from "axios";
// import React, { useState } from "react";
// import { REACT_APP_API_PORT } from "../../Api";

// const NewsletterForm = () => {
//   const [email, setEmail] = useState("");
//   const [message, setMessage] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);

//   const handleSubmit = async(e) => {
//     try{
//       e.preventDefault();
//       setIsLoading(true);
//       const res = await axios.post(`${REACT_APP_API_PORT}user/auth/add-newsletter-subscriber`, {
//         email,
//       });
//       setIsLoading(false);
//       if(res.data.status){
//         setEmail("")
//         setMessage({ type: "success", text: "You have been successfully subscribed!" });
//       }
//     }
//     catch(err){
//       setIsLoading(false);
//       if(err?.response?.data?.status===false){
//         setMessage({ type: "error", text: err?.response?.data?.message });
//       }

//     }

//   };


//   return (
//     <div className="w-full py-20 bg-black text-white">
//       <div className="max-w-[80rem] px-4 mx-auto text-center">
//         <h2 className="text-3xl font-extrabold mb-6">Stay Updated!</h2>
//         <p className="mb-6 text-gray-300">
//           Subscribe to our newsletter to get the latest updates directly in your inbox.
//         </p>
//         <form
//           className="flex flex-col md:flex-row items-center justify-center gap-4 max-w-[40rem] mx-auto"
//           onSubmit={handleSubmit}
//         >
//           {/* Email Input */}
//           <div className="w-full md:w-auto flex-grow">
//             <input
//               type="email"
//               name="email"
//               placeholder="Enter your email address"
//               required
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               className="w-full px-4 py-3 rounded text-white border border-[#e8e8e857] focus:outline-none focus:ring-2 focus:ring-blue-500 bg-background-back1 "
//             />
//           </div>

//           {/* Subscribe Button */}
//           <div>
//             <button
//               type="submit"
//               className="w-full md:w-auto px-6 py-3 border-2 border-customBlue text-white rounded font-semibold hover:bg-background-primary focus:ring-2 focus:ring-blue-500 disabled:bg-blue-400 transition duration-200"
//               disabled={isLoading}
//             >
//               {isLoading ? "Subscribing..." : "Subscribe"}
//             </button>
//           </div>
//         </form>

//         {/* Success/Error Message */}
//         {message && (
//           <div
//             className={`mt-6 text-center text-lg ${
//               message.type === "success" ? "text-green-500" : "text-red-500"
//             }`}
//           >
//             {message.text}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default NewsletterForm;


import axios from "axios";
import React, { useEffect, useState } from "react";
import { REACT_APP_API_PORT } from "../../Api";

const NewsletterForm = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setIsLoading(true);
      const res = await axios.post(`${REACT_APP_API_PORT}user/auth/add-newsletter-subscriber`, {
        email,
      });
      setIsLoading(false);
      if (res.data.status) {
        setEmail("")
        setMessage({ type: "success", text: "You have been successfully subscribed!" });
      }
    }
    catch (err) {
      setIsLoading(false);
      if (err?.response?.data?.status === false) {
        setMessage({ type: "error", text: err?.response?.data?.message });
      }

    }

  };

  const getData = async () => {
    try {
      setIsLoading(true);
      const res = await axios.get(
        `${REACT_APP_API_PORT}user/homepage/newsletter-section-details`
      );
      setIsLoading(false);
      setData(res.data.data);
    } catch (err) {
      setIsLoading(false);
      console.log(err);
    }
  };

  useEffect(() => {
    getData()
  }, [])


  return (
    <section className="w-full py-2 px-4 text-white bg-black">
      <div className="max-w-[70rem] pt-[60px] pb-[60px] mx-auto rounded-2xl text-center relative overflow-hidden">

        {/* Soft Glows inside the box */}

        {/* Content */}
        <div className="relative z-10 px-4">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 tracking-tight drop-shadow-[0_2px_10px_rgba(0,0,0,0.2)]">
            {data?.heading1 || "Stay"} <span className="gradient-text">{data?.heading2 || "Updated"}</span>
          </h2>

          {/* <p className="text-white/80 text-lg mb-10 max-w-2xl mx-auto">
            Join our newsletter to get the latest updates straight to your inbox.
          </p> */}
          <div
            className="text-white/80 text-lg mb-10 max-w-2xl mx-auto"
            dangerouslySetInnerHTML={{ __html: data?.description }}
          />

          <form
            onSubmit={handleSubmit}
            className="bg-white/5 backdrop-blur-lg max-w-2xl mx-auto border border-white/10 p-5 rounded-2xl flex flex-col md:flex-row items-center gap-4"
          >
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              className="flex-1 w-full px-5 py-3 rounded-lg bg-black/10 text-white placeholder-gray-400 border border-white/10 focus:outline-none focus:ring-2 focus:ring-[#00bf67] transition"
            />

            <button
              type="submit"
              disabled={isLoading}
              className="px-6 py-3 w-full md:w-auto rounded-full bg-[linear-gradient(45deg,#d54d09,#e1307a,#9443ff,#436cff)] hover:bg-[linear-gradient(45deg,#ff7a18,#ff0066,#9b30ff,#3a7bd5)] text-white font-semibold hover:brightness-110 transition disabled:opacity-50"
            >
              {isLoading ? "Subscribing..." : "Subscribe"}
            </button>
          </form>

          {message && (
            <div
              className={`mt-6 text-base font-medium ${message.type === 'success' ? 'text-green-400' : 'text-red-500'
                }`}
            >
              {message.text}
            </div>
          )}
        </div>
      </div>
    </section>


  );
};

export default NewsletterForm;
